import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  chartWrapper: {
    width: "100%",
    height: 1000,
    paddingBottom: 40
  },
  expandedWrapper: {
    height: 200,
    paddingBottom: 50
  },
  chartTitle: {
    display: "block",
    width: "100%",
    textAlign: "center",
    fontSize: 14,
    fontWeight: 600,
    color: colour.grey[300],
    marginTop: 10
  },
  expanderWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    top: -12
  },
  expanderExpanded: {
    top: 10
  },
  chartX: {
    display: "flex",
    padding: "10px 15px 0 36px",
    background: "#fff"
  },
  chartXItem: {
    textDecoration: "none",
    textAlign: "center",
    flex: "1 0 0"
  },
  chartXTitle: {
    fontSize: 12,
    color: colour.grey[300],
    fontWeight: 600
  },
  chartExpander: {
    fontSize: 14,
    fontWeight: 600,
    color: colour.grey[300],
    border: `1px solid ${colour.grey[300]}`,
    borderRadius: 12,
    padding: "3px 10px",
    background: "#FFFFFF",
    cursor: "pointer",
    position: "relative",
    paddingRight: 25
  },
  icon: {
    fontSize: 20,
    fontStyle: "normal",
    position: "absolute",
    right: 9,
    top: -1
  }
});
